import { BrazeIcon, Button, FlexBox, Heading } from "@braze/beacon-core"
import { getColor } from "@braze/beacon-styling"
import { MouseEventHandler } from "react"
import styled from "styled-components"



export const SignInBlock = ({login} : {login:MouseEventHandler}) => {
    
    return (
        <LoginBackground>
            <LoginBox>
                <LoginCard>
                    <Heading>Braze Builder</Heading>
                    <Heading level={3}>A marketing tool to create, view, and analyze campaigns.</Heading>
                    <LoginButton onClick={login}>
                        Login with Okta SSO
                    </LoginButton>
                </LoginCard>
            </LoginBox>
        </LoginBackground>
    )
}

const LoginButton = styled(Button)`
       
`

const LoginBackground = styled(FlexBox)`
    background: url("img/braze-gradient.svg");
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: fixed;
    height: 100%;
    // transform: scaleY(-1);
    right: 0;
    bottom: 0;
    left: 0;
    overflow: scroll;
    flex-direction: column;
    justify-content: center;

`;

const LoginBox = styled(FlexBox)`
    background: #FFF;
    width: 40%;
    margin: auto;
    padding: 3rem;
    box-shadow: 0 2px 6px 0 rgb(0 0 0 / 10%);
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
    margin-top: 15rem;
    position: relative;
    border-radius: 2em;
    z-index: 100;
`

const LoginCard = styled(FlexBox)`
    // background: black;
    min-width: 60%;
    min-hegiht: 30%;
    flex-direction: column;

    ${LoginButton} {

        background: ${getColor("blue", 600)};
    }

    &:hover ${LoginButton} {
        // background: red;
    }
    
`